const getParticipationsCollectionPath = (userId: string) =>
  `userData/${userId}/participations`;

export const getParticipationDocumentPath = (
  userId: string,
  participationId: string
) => `${getParticipationsCollectionPath(userId)}/${participationId}`;
